
export { SimpleFormatPipe } from './simple-format.pipe';